export default __webpack_public_path__ + "static/media/renault.d9e23866.webp";